var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditimg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9608 7.16342V6.80775C22.9608 5.17274 21.6306 3.84253 19.9956 3.84253H2.96522C1.33016 3.84258 0 5.17274 0 6.80775V7.16342H22.9608Z",
    fill: "#FF82AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5651 16.7017C13.5651 15.1636 14.0598 13.7017 14.9731 12.4968H0V16.6331C0 18.2681 1.33016 19.5983 2.96522 19.5983H14.1911C13.7813 18.7007 13.5651 17.7179 13.5651 16.7017ZM11.4804 15.803H8.92125V14.2796H11.4804V15.803ZM3.41545 14.2796H7.39781V15.803H3.41545V14.2796Z",
    fill: "#FF82AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5547 10.9734C17.7165 10.1606 19.0967 9.72262 20.5443 9.72262C21.3822 9.72262 22.1973 9.86974 22.9608 10.1509V8.68689H0V10.9734H16.5547Z",
    fill: "#FF82AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 16.7018C25.9998 13.6887 23.5572 11.2461 20.5441 11.2461C17.531 11.2461 15.0884 13.6887 15.0884 16.7018C15.0884 19.7149 17.531 22.1575 20.5441 22.1575C23.5572 22.1575 25.9998 19.7149 25.9998 16.7018ZM21.2795 19.6164V20.2364H20.5178V20.2364V20.2364H19.7561V19.6209C19.2956 19.465 18.9188 19.1906 18.5508 18.9215L19.4501 17.6919C19.9445 18.0534 20.1975 18.2272 20.5441 18.2272C20.7401 18.2272 20.8988 18.1339 20.9583 17.9838C21.0303 17.802 20.9286 17.6345 20.6859 17.5357C20.6859 17.5357 19.5971 17.1726 19.0937 16.6593C18.6714 16.2288 18.537 15.622 18.6715 15.0447C18.8069 14.4635 19.1993 14.0091 19.7561 13.7822V13.1671H21.2795V13.7567C21.6664 13.8641 21.9939 14.0229 22.1822 14.1251L21.4554 15.464C20.9735 15.2024 20.5301 15.1239 20.3576 15.1829C20.1902 15.2401 20.1647 15.3493 20.1551 15.3904C20.1416 15.4486 20.1343 15.538 20.2274 15.6418C20.3171 15.7417 21.2603 16.1248 21.2603 16.1248C22.2781 16.5391 22.7571 17.5795 22.3746 18.5449C22.1759 19.0467 21.7759 19.4267 21.2795 19.6164Z",
    fill: "#FF82AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditimg2);
export default __webpack_public_path__ + "static/media/creditimg2.6d9caebdb965f2139121cb703598fc8b.svg";
export { ForwardRef as ReactComponent };